<!--
* UIID: UI-DLB-MAP-110
* UI Name: Add Map
* Modify Date: 2020/05/19
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display add-map-layout-dialog custom-add-map-layout-dialog"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text" primary-title>
        {{
          options.item.action == 'add'
            ? $t('lbl.mapManager.mapLayout.addMap')
            : $t('lbl.mapManager.mapLayout.modifyMap')
        }}
      </v-card-title>
    </template>
    <template v-slot:button-close>
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-card class="dialog-container">
      <!-- [S]  Popup body-->
      <v-card-text class="pb-0">
        <!-- 203705_MapManager_Fix issues_9 -->
        <v-form ref="form" class="dialog-content">
          <v-row class="ml-0 mr-0">
            <v-col class="required-col field-col pt-0" lg="2">
              <v-icon x-small>fas fa-asterisk</v-icon>
              <span class="field-label required-text">
                {{ $t('lbl.mapManager.mapLayout.mapName') }}
              </span>
            </v-col>
            <v-col lg="5" class="pl-0 pt-0">
              <v-text-field
                v-model="addMapFileLayoutHeader.data[0].MAP_NAME"
                :rules="[validationUtils.required]"
                class="data-table-filter-text-field inline-block-component text-field-flatfile-layout map-name-textfield"
                ref="refMapName"
                heigth="30"
                outlined
                dense
                solo
              ></v-text-field>
            </v-col>
            <v-col class="field-col pt-0 " lg="2">
              <v-icon x-small>fas fa-asterisk</v-icon>
              <span class="field-label required-text">
                {{ $t('lbl.mapManager.mapLayout.message') }}
              </span>
            </v-col>
            <v-col lg="3" class="map-text-field pl-0 pt-0">
              <v-autocomplete
                v-model="addMapFileLayoutHeader.data[0].MAP_MSG_ID"
                :items="EDIMesList"
                :menu-props="{ offsetY: true }"
                :rules="[validationUtils.required]"
                class="custom-selectbox edi-mes-list"
                ref="refMessage"
                dense
                solo
              >
                <template slot="selection" slot-scope="data">
                  {{ data.item.value }}
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col class="required-col field-col " lg="2">
              <v-icon x-small>fas fa-asterisk</v-icon>
              <span class="field-label required-text">
                {{ $t('lbl.mapManager.mapLayout.mapType') }}
              </span>
            </v-col>
            <v-col lg="5" class="map-type-col pl-0">
              <v-select
                v-model="map_type_from"
                @change="filterMapType"
                :items="codeItem"
                :rules="[validationUtils.required]"
                class="data-table-select-box srm-select-box custom-selectbox flatfile-layout-selectbox communication-select-box pt-0"
                ref="refMapTypeForm"
                height="30"
                dense
                solo
                outlined
              >
              </v-select>
              <span class="field-label to-text">
                {{ $t('lbl.mapManager.mapLayout.to') }}
              </span>
              <v-select
                v-model="map_type_to"
                :items="codeItem"
                :rules="[validationUtils.required]"
                class="data-table-select-box srm-select-box custom-selectbox flatfile-layout-selectbox communication-select-box pt-0"
                ref="refMapTypeTo"
                height="30"
                dense
                solo
                outlined
              >
              </v-select>
            </v-col>
            <v-col class="field-col" lg="2" v-if="this.icon">
              <v-icon x-small>fas fa-asterisk</v-icon>
              <span class="field-label required-text">
                {{ $t('lbl.mapManager.mapLayout.ediVersion') }}
              </span>
            </v-col>
            <v-col class="field-col edi-version-col" lg="2" v-else>
              <span class="field-label required-text">
                {{ $t('lbl.mapManager.mapLayout.ediVersion') }}
              </span>
            </v-col>
            <v-col lg="3" class="map-text-field pl-0" v-if="this.icon" ref="eDI_version">
              <v-autocomplete
                v-model="addMapFileLayoutHeader.data[0].MAP_MSG_VER"
                @change="changeEdiList"
                :items="EDIVesionList"
                :rules="[validationUtils.required]"
                class="data-table-select-box srm-select-box custom-selectbox flatfile-layout-selectbox communication-select-box pt-0"
                ref="refEdiVersion"
                dense
                solo
              >
              </v-autocomplete>
            </v-col>
            <v-col lg="3" class="map-text-field pl-0" v-if="!this.icon" ref="eDI_version">
              <v-autocomplete
                v-model="addMapFileLayoutHeader.data[0].MAP_MSG_VER"
                @change="changeEdiList"
                :items="EDIVesionList"
                class="data-table-select-box srm-select-box custom-selectbox flatfile-layout-selectbox communication-select-box pt-0"
                ref="refEdiVersion"
                dense
                solo
                hide-details
              >
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col v-if="options.item.action === 'add'" class="required-col field-col" lg="2">
              <v-icon x-small>fas fa-asterisk</v-icon>
              <span class="field-label required-text">
                {{ $t('lbl.mapManager.mapLayout.mapperFile') }}
              </span>
            </v-col>
            <v-col v-if="options.item.action != 'add'" class="not-required-col field-col" lg="2">
              <span class="field-label required-text">
                {{ $t('lbl.mapManager.mapLayout.mapperFile') }}
              </span>
            </v-col>
            <v-col v-if="options.item.action != 'add'" lg="10" class="map-text-field pl-0">
              <v-text-field
                v-model="addMapFileLayoutHeader.data[0].MAPPER_NAME"
                class="data-table-filter-text-field text-field-flatfile-layout readonly-textfield"
                heigth="30"
                readonly
                outlined
                hide-details
                dense
                solo
              ></v-text-field>
              <input
                id="mapfile_layout_input"
                type="file"
                ref="mapfile_layout_input"
                style="display: none"
              />
            </v-col>
            <v-col
              v-if="options.item.action == 'add'"
              :lg="isDlb ? 7 : 10"
              class="map-text-field inline-block-component pl-0"
            >
              <v-text-field
                v-model="addMapFileLayoutHeader.data[0].MAPPER_NAME"
                :rules="[validationUtils.required]"
                class="data-table-filter-text-field inline-block-component text-field-flatfile-layout"
                ref="refMapperName"
                heigth="30"
                width="100"
                outlined
                dense
                solo
                readonly
              ></v-text-field>
              <input
                @change="onFlatFileChanged"
                id="mapfile_layout_input"
                type="file"
                ref="mapfile_layout_input"
                style="display: none"
              />
              <v-btn
                :class="['btn ml-3 btn-popup-search', isDlb ? 'mr-3' : '']"
                color="primary"
                @click="openLoadFilePop({ mode: 'Load', filetype: 'mapper' })"
              >
                {{ $t('btn.mapManager.load') }}
              </v-btn>
            </v-col>
            <v-col
              v-if="options.item.action == 'add' && isDlb"
              lg="3"
              class="map-text-field pr-0 pl-0"
            >
              <v-select
                v-model="libraryVersion"
                @change="onVersionChange(libraryVersion)"
                :items="libraryItem"
                :rules="[validationUtils.required]"
                class="data-table-select-box srm-select-box custom-selectbox flatfile-layout-selectbox communication-select-box"
                ref="refMapTypeTo"
                height="30"
                dense
                solo
                outlined
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row v-if="isDlb">
            <v-col
              :lg="options.item.action == 'add' ? 8 : 12"
              :class="
                options.item.action == 'add'
                  ? 'customer-add-map-layout pr-7'
                  : 'customer-add-map-layout'
              "
            >
              <div class="layout-chkin-color_u">
                <a
                  :style="options.item.action != 'add' ? '' : 'position: absolute;right: 37%;'"
                  @click="openCodeTableDialog"
                  >{{ selectCodeName }}</a
                >
                <a v-if="codelistFlag" class="pl-3" @click="downloadCodeList(selectCodeId)">{{
                  $t('tbl.mapManager.versionHistory.download1')
                }}</a>
              </div>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col lg="12" class="customer-add-map-layout pr-3">
              <div class="layout-chkin-color_u">
                <a
                  :style="options.item.action != 'add' ? '' : 'position: absolute;right: 2%;'"
                  @click="openCodeTableDialog"
                  >{{ selectCodeName }}</a
                >
              </div>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col v-if="options.item.action != 'add'" class="not-required-col field-col " lg="2">
              <span class="field-label required-text">
                {{ $t('lbl.mapManager.mapLayout.comment') }}
              </span>
            </v-col>
            <v-col v-if="options.item.action === 'add'" class="required-col field-col " lg="2">
              <v-icon x-small hidden>fas fa-asterisk</v-icon>
              <span class="field-label required-text">
                {{ $t('lbl.mapManager.mapLayout.comment') }}
              </span>
            </v-col>
            <v-col v-if="options.item.action != 'add'" lg="10" class="map-text-field pl-0">
              <v-text-field
                v-model="addMapFileLayoutHeader.data[0].MAPPER_COMT"
                :class="[
                  'data-table-filter-text-field',
                  'text-field-flatfile-layout',
                  options.item.action != 'add' ? 'readonly-textfield' : '',
                ]"
                heigth="30"
                outlined
                hide-details
                dense
                solo
              ></v-text-field>
            </v-col>
            <v-col lg="10" v-if="options.item.action === 'add'" class="map-text-field pl-0">
              <v-text-field
                v-model="addMapFileLayoutHeader.data[0].MAPPER_COMT"
                :class="[
                  'data-table-filter-text-field',
                  'text-field-flatfile-layout',
                  options.item.action != 'add' ? 'readonly-textfield' : '',
                ]"
                :rules="[validationUtils.required]"
                ref="refMapperComt"
                heigth="30"
                outlined
                dense
                solo
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col class="not-required-col field-col " lg="2">
              <span class="field-label required-text">
                {{ $t('lbl.mapManager.mapLayout.scannerFile') }}
              </span>
            </v-col>
            <v-col v-if="options.item.action != 'add'" lg="10" class="map-text-field pl-0">
              <v-text-field
                v-model="addMapFileLayoutHeader.data[0].SCANNER_NAME"
                class="data-table-filter-text-field text-field-flatfile-layout readonly-textfield"
                heigth="30"
                readonly
                outlined
                hide-details
                dense
                solo
              ></v-text-field>
              <input
                id="scanfile_layout_input"
                type="file"
                ref="scanfile_layout_input"
                style="display: none"
              />
            </v-col>
            <v-col
              v-if="options.item.action == 'add'"
              lg="10"
              class="map-text-field inline-block-component pl-0"
            >
              <v-text-field
                v-model="addMapFileLayoutHeader.data[0].SCANNER_NAME"
                class="data-table-filter-text-field inline-block-component text-field-flatfile-layout flatfile-textfield scanner-textfield"
                heigth="30"
                outlined
                hide-details
                dense
                solo
                readonly
              ></v-text-field>
              <input
                id="scanfile_layout_input"
                type="file"
                ref="scanfile_layout_input"
                style="display: none"
                @change="onCsvFileChanged"
              />
              <v-btn
                class="btn ml-3 btn-popup-search"
                v-if="disable_Scan"
                color="primary"
                @click="openLoadFilePop({ mode: 'Load', filetype: 'scanner' })"
              >
                {{ $t('btn.mapManager.load') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col class="not-required-col field-col" lg="2">
              <span class="field-label required-text">
                {{ $t('lbl.mapManager.mapLayout.comment') }}
              </span>
            </v-col>
            <v-col lg="10" class="map-text-field pl-0">
              <v-text-field
                v-model="addMapFileLayoutHeader.data[0].SCANNER_COMT"
                :class="[
                  'data-table-filter-text-field',
                  'text-field-flatfile-layout',
                  options.item.action != 'add' ? 'readonly-textfield' : '',
                ]"
                heigth="30"
                outlined
                hide-details
                dense
                solo
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col class="not-required-col field-col" lg="3">
              <span class="field-label required-text">
                {{ $t('lbl.mapManager.mapLayout.flatFileLayout') }}
              </span>
            </v-col>
            <v-col lg="9" class="map-text-field inline-block-component pl-0">
              <v-text-field
                v-model="addMapFileLayoutHeader.data[0].FFL_FILE_NAME"
                class="data-table-filter-text-field inline-block-component text-field-flatfile-layout flatfile-textfield"
                heigth="30"
                readonly
                outlined
                hide-details
                dense
                solo
              ></v-text-field>
              <v-btn class="btn btn-popup-search" color="primary" @click="openFlatFileLayoutList()">
                {{ $t('btn.mapManager.load') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col class="not-required-col field-col pb-0" lg="3">
              <span class="field-label required-text">
                {{ $t('lbl.mapManager.mapLayout.mappingDefinition') }}
              </span>
            </v-col>
            <v-col lg="9" class="map-text-field inline-block-component pl-0 pb-0">
              <v-text-field
                v-model="mapDefinitionFileName"
                class="data-table-filter-text-field inline-block-component text-field-flatfile-layout flatfile-textfield"
                heigth="30"
                readonly
                outlined
                hide-details
                dense
                solo
              ></v-text-field>
              <v-btn
                class="btn btn-popup-search"
                color="primary"
                @click="openMappingDefinitionList()"
              >
                {{ $t('btn.mapManager.load') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
        <v-divider class="ml-0 mr-0 divder-popup" inset></v-divider>
        <v-row class="ml-0 mr-0">
          <v-col class="button-col action-col" lg="12">
            <div class="btn-form-control text-right">
              <v-btn class="btn btn-delete btn-popup" @click="removeDialog">
                {{ $t('btn.common.close') }}
              </v-btn>
              <v-btn class="btn btn-popup-search btn-popup" color="primary" @click="onSave">
                {{ $t('btn.common.save') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup body-->
    </v-card>
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import { mapState } from 'vuex';
import cfg from '@/vue-caas/config/config.js';
import { DownloadFile } from '@/vue-dlb/models/DownloadFile';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import { getEditData } from '@/vue-caas/utils/process';

export default {
  components: {
    DialogDrag,
    IconSvg,
  },
  name: 'add-map-layout-dialog',
  /* 2020/10/29 203737 Change prop definitions
  props: ['id', 'title', 'options', 'eventCb', 'closeDialog', 'dragStart', 'dragEnd','flatFile'],*/
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
  },
  computed: {
    ...mapState('mapbuilder', {
      libList: 'libList',
    }),
    ...mapState('common', {
      EDIVerList: 'EDIVerList',
      /* 2020/11/06 203737 Remove unused source
        EDIMsgTypeList:"EDIMsgTypeList",*/
      CommMsgList: 'CommMsgList',
      codeList: 'codeList',
      repomenuMode: 'repomenuMode',
    }),
    ...mapState('map', {
      mapData: 'mapData',
      codeListResult: 'codeListResult',
    }),
    /* 2020/11/06 203737 Remove unused source
    ...mapState("common", {
      fileContent: "fileContent",
    }),*/
    disable_comment() {
      if (this.options.item.action == 'add') {
        if (this.disable_Scan == false) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    },
  },
  data() {
    return {
      mode: '',
      filetype: '',
      selectCodeName: this.$t('lbl.mapBuilder.builderCheckIn.codeCovertingTable'),
      selectCodeId: '',
      fileLoaded: '',
      scannerLoaded: '',
      ACCESS_REPO_YN: '', // common mandatory for ADMIN_YN
      /* 2020/11/06 203737 Remove unused source
    value: null,*/
      icon: false,
      mandatoryField: false,
      contenInput: '',
      disable_Scan: true,
      /* 2020/11/06 203737 Remove unused source
    add_valid_str: '',*/
      map_type_from: '',
      map_type_to: '',
      mapDefinitionFileName: '',
      codelistFlag: false,
      /* 2020/11/06 203737 Remove unused source
    item: {
      flatfile: '',
      mapDefinitionFile:'',
      comment: '',
      csv_file: ''
    },*/
      mapConVersionType: [],
      /* 2020/11/06 203737 Remove unused source
    businessNameList: [{
      text: 'text',
      value: 'value'
    }],
    typeList: ['text'],*/
      modifyMap: {
        header: ['MAP_PRCS_NO'],
        data: [
          {
            MAP_PRCS_NO: '',
          },
        ],
      },
      addMapFileLayoutHeader: {
        header: [
          'ADMIN_YN',
          'CUST_ID',
          'OWNR_CUST_ID',
          'MAP_CONV_TP',
          'MAP_MSG_VER',
          'MAP_MSG_ID',
          'MAP_NAME',
          'FFL_PRCS_NO',
          'MPD_PRCS_NO',
          'MAPPER_NAME',
          'MAPPER_FILE_ID',
          'MAPPER_SIZE',
          'MAPPER_COMT',
          'SCANNER_NAME',
          'SCANNER_FILE_ID',
          'SCANNER_SIZE',
          'SCANNER_COMT',
          'FFL_FILE_NAME',
          'CODE_CTG_ID',
          'LIB_VER',
          'ORA_VER',
          'TARGET_MAPPER_ID',
          'TARGET_MAPPER_NAME',
          'TARGET_SCANNER_ID',
          'TARGET_SCANNER_NAME',
          'mappfile',
          'scanfile',
        ],
        data: [
          {
            ADMIN_YN: '',
            CUST_ID: '',
            OWNR_CUST_ID: '',
            MAP_CONV_TP: '',
            MAP_MSG_VER: '',
            MAP_MSG_ID: '',
            MAP_NAME: '',
            FFL_PRCS_NO: '',
            MPD_PRCS_NO: '',
            MAPPER_NAME: '',
            MAPPER_FILE_ID: '',
            MAPPER_SIZE: '',
            MAPPER_COMT: '',
            SCANNER_NAME: '',
            SCANNER_FILE_ID: '',
            SCANNER_SIZE: '',
            SCANNER_COMT: '',
            FFL_FILE_NAME: '',
            CODE_CTG_ID: '',
            LIB_VER: '',
            ORA_VER: '',
            TARGET_MAPPER_ID: '',
            TARGET_MAPPER_NAME: '',
            TARGET_SCANNER_ID: '',
            TARGET_SCANNER_NAME: '',
            mappfile: null,
            scanfile: null,
          },
        ],
      },
      updateMapFileLayoutHeader: {
        header: [
          'MAP_PRCS_NO',
          'MAP_CONV_TP',
          'MAP_MSG_VER',
          'MAP_MSG_ID',
          'MAP_NAME',
          'FFL_PRCS_NO',
          'CODE_CTG_ID',
          'MPD_PRCS_NO',
          'MAPPER_COMT',
          'SCANNER_COMT',
        ],
        data: [
          {
            MAP_PRCS_NO: '',
            MAP_CONV_TP: '',
            MAP_MSG_VER: '',
            MAP_MSG_ID: '',
            MAP_NAME: '',
            FFL_PRCS_NO: '',
            CODE_CTG_ID: '',
            MPD_PRCS_NO: '',
            MAPPER_COMT: '',
            SCANNER_COMT: '',
          },
        ],
      },
      EDIVesionList: [{ text: 'Type', value: '' }],
      EDIMesList: [{ text: 'Type', value: '' }],
      codeItem: [{ text: 'Type', value: '' }],
      EDIVesionSearchItems: {
        header: ['PARAM'],
        data: [
          {
            PARAM: '',
          },
        ],
      },
      /* 2020/11/06 203737 Remove unused source
    EDIMsgTypeListSearchItems: {
      header: ['MSG_VER'],
      data: [{
        MSG_VER:'',
      }],
    },*/
      codeSearchItems: {
        header: ['GRP_CODE'],
        data: [
          {
            GRP_CODE: '',
          },
        ],
      },
      librarySearchItem: {
        header: ['CUST_ID'],
        data: [
          {
            CUST_ID: '',
          },
        ],
      },
      codeListCreate: {
        header: ['CODE_CTG_ID', 'DIV_KUBUN', 'SITE_CODE', 'SUB_DIR'],
        data: [
          {
            CODE_CTG_ID: '',
            DIV_KUBUN: 'ASSET',
            SITE_CODE: '',
            SUB_DIR: '',
          },
        ],
      },
      libraryItem: [{ text: 'Compile library', value: '' }],
      libraryVersion: '',
      oracleVersion: '',
      isDlb: false,
      previousMapperComment: '',
      previousScannerComment: '',
    };
  },
  created() {
    this.codelistFlag = false;
    this.mapConVersionType = this.options.item.codeItem;
    // By April to Show EDI Asset depending on Authority.
    // Check whether entered from repository menu on top selection of customer or User menu
    if (this.repomenuMode) {
      // Repository Menu
      if ($cookies.get('comp-id') == cfg.provider) this.ACCESS_REPO_YN = 'NY';
      // CLT Super Provider
      else this.ACCESS_REPO_YN = 'YN'; // Normal User Admin
    } else {
      // Normal User
      this.ACCESS_REPO_YN = 'NN';
    }
    this.addMapFileLayoutHeader.data[0].ADMIN_YN = this.ACCESS_REPO_YN;
    this.addMapFileLayoutHeader.data[0].CUST_ID = $cookies.get('comp-id');
    this.addMapFileLayoutHeader.data[0].OWNR_CUST_ID = $cookies.get('ownr-id');
    if (this.options.item.action != 'add') {
      let data = this.options.item.data;
      // 193557 Map Manager fix issue 11,13
      this.modifyMap.data[0].MAP_PRCS_NO = data.MAP_PRCS_NO;

      Store.dispatch('map/getMapInfo', this.modifyMap).then(() => {
        console.log('--------- Finished to process ----------');
        this.addMapFileLayoutHeader.data[0].MAP_NAME = this.mapData[0].MAP_NAME;
        this.addMapFileLayoutHeader.data[0].MAP_CONV_TP = this.mapData[0].MAP_CONV_TP;
        this.addMapFileLayoutHeader.data[0].MAPPER_NAME = this.mapData[0].MAPPER_NAME;
        this.addMapFileLayoutHeader.data[0].MAPPER_COMT = this.mapData[0].MAPP_COMT;
        this.previousMapperComment = this.mapData[0].MAPP_COMT;
        this.addMapFileLayoutHeader.data[0].SCANNER_NAME = this.mapData[0].SCANNER_NAME;
        this.addMapFileLayoutHeader.data[0].SCANNER_COMT = this.mapData[0].SCAN_COMT;
        this.previousScannerComment = this.mapData[0].SCAN_COMT;
        this.addMapFileLayoutHeader.data[0].FFL_FILE_NAME = this.mapData[0].FFL_FILE_NAME;
        this.addMapFileLayoutHeader.data[0].FFL_PRCS_NO = this.mapData[0].FFL_PRCS_NO;
        this.addMapFileLayoutHeader.data[0].MPD_PRCS_NO = this.mapData[0].MPD_PRCS_NO;
        this.addMapFileLayoutHeader.data[0].MAP_PRCS_NO = this.mapData[0].MAP_PRCS_NO;
        this.addMapFileLayoutHeader.data[0].MAP_MSG_VER = this.mapData[0].MAP_MSG_VER;
        this.addMapFileLayoutHeader.data[0].MAP_MSG_ID = this.mapData[0].MAP_MSG_ID;
        this.map_type_to = this.mapData[0].MAP_CONV_TP_TO;
        this.map_type_from = this.mapData[0].MAP_CONV_TP_FROM;
        this.mapDefinitionFileName = this.mapData[0].MPD_FILE_NAME;

        if (this.options.item.data.CODE_CTG_ID != null) {
          this.selectCodeName = this.options.item.data.CODE_CTG_NAME;
          this.selectCodeId = this.options.item.data.CODE_CTG_ID;
          this.codelistFlag = true;
        }

        if (this.map_type_from == 'E' || this.map_type_from == 'A') {
          this.mandatoryField = true;
        } else {
          this.mandatoryField = false;
        }
        console.log(this.options.item.data);
      });
    }
    this.contenInput = '';
    this.getEDIVesion();
    this.getEDIMsgTypeList();
    this.getCode();
    this.isDlb = cfg.isDlb;
    this.getLibraryVersion();
  },
  mounted() {
    setTimeout(() => {
      this.$refs.refMapName.focus();
    }, 300);
  },
  watch: {
    mandatoryField() {
      if (this.mandatoryField) {
        this.$refs.eDI_version.classList.add('mandatory');
        this.icon = true;
      }
    },
  },
  methods: {
    getLibraryVersion() {
      this.librarySearchItem.data[0].CUST_ID = $cookies.get('comp-id');
      Store.dispatch('mapbuilder/queryLibraryList', this.librarySearchItem).then(() => {
        for (let i = 0; i < this.libList.length; i++) {
          if (this.isDlb) {
            let item = this.libList[i];
            this.libraryItem.push({
              text: item.SITE_NAME,
              value: item.SITE_CODE,
            });
          } else {
            if (this.libList[i].SITE_CODE === 'for_platform') {
              let item = this.libList[i];
              this.libraryItem.push({
                text: item.SITE_NAME,
                value: item.SITE_CODE,
              });
            }
          }
        }
        if ($cookies.get('comp-name').toLowerCase() === 'cyberlogitec') {
          this.libraryVersion = 'for_platform';
        } else if ($cookies.get('comp-name').toLowerCase() === 'btp') {
          this.libraryVersion = 'btp';
        } else {
          let item = this.libraryItem.filter(
            (e) => e.text.toLowerCase() == $cookies.get('comp-name').toLowerCase()
          );
          this.libraryVersion = item[0].value;
        }
      });
    },
    onVersionChange(libver) {
      for (let i = 0; i < this.libList.length; i++) {
        if (libver === this.libList[i].SITE_CODE) {
          this.oracleVersion = this.libList[i].ORA_VER;
          break;
        }
      }
    },
    getEDIVesion() {
      this.EDIVesionSearchItems.data[0].PARAM = '';
      Store.dispatch('common/getEDIVersionList', this.EDIVesionSearchItems).then(() => {
        for (let i = 0; i < this.EDIVerList.length; i++) {
          let EDIVerObj = {};
          EDIVerObj.text = this.EDIVerList[i].MSG_VER;
          EDIVerObj.value = this.EDIVerList[i].MSG_VER;
          this.EDIVesionList.push(EDIVerObj);
        }
      });
    },
    getEDIMsgTypeList() {
      let commMsgSearchItems = {
        header: ['MSG_NM'],
        data: [
          {
            MSG_NM: '',
          },
        ],
      };
      Store.dispatch('common/getCommonMessageList', commMsgSearchItems).then(() => {
        console.log('--------- Finished to process MES ----------');
        for (let i = 0; i < this.CommMsgList.length; i++) {
          let EDIVerObj = {};
          EDIVerObj.text = this.CommMsgList[i].MSG_CD + '(' + this.CommMsgList[i].MSG_NM + ')';
          EDIVerObj.value = this.CommMsgList[i].MSG_CD;
          this.EDIMesList.push(EDIVerObj);
        }
      });
    },
    getCode() {
      this.codeSearchItems.data[0].GRP_CODE = 'B06';
      Store.dispatch('common/getCode', this.codeSearchItems).then(() => {
        for (let i = 0; i < this.codeList.length; i++) {
          let codeObj = {};
          codeObj.text = this.codeList[i].CM_CODE_NAME;
          codeObj.value = this.codeList[i].CM_CODE_ID;
          this.codeItem.push(codeObj);
        }
      });
    },
    /* 2020/10/28 203737 Remove unused source
    clickBrowseMapFile(){
      this.$refs.mapfile_layout_input.click();
    },
    clickBrowseScanFile(){
      this.$refs.scanfile_layout_input.click();
    },*/
    onSave() {
      // 203705_MapManager_Fix issues_9
      let validResult = this.$refs.form.validate();
      if (validResult) {
        if (this.options.item.action == 'add') {
          this.addMapFileLayoutHeader.data[0].MAP_CONV_TP =
            this.map_type_from + '2' + this.map_type_to;
          // CLV-Change Load CODE_CTG_ID from Select Code Table
          this.addMapFileLayoutHeader.data[0].CODE_CTG_ID = this.selectCodeId; // TBD - by April. Please change here for CodeTable
          if (this.isDlb) {
            this.addMapFileLayoutHeader.data[0].LIB_VER = this.libraryVersion;
          } else {
            this.addMapFileLayoutHeader.data[0].LIB_VER = 'for_platform';
          }
          this.addMapFileLayoutHeader.data[0].ORA_VER = this.oracleVersion;
          Store.dispatch('map/saveAddMap', this.addMapFileLayoutHeader).then(() => {
            console.log('--------- Finished to process ----------');
            this.removeDialogRefesh({});
          });
        } else {
          this.updateMapFileLayoutHeader.data[0].MAP_PRCS_NO = this.addMapFileLayoutHeader.data[0].MAP_PRCS_NO;
          this.updateMapFileLayoutHeader.data[0].MAP_NAME = this.addMapFileLayoutHeader.data[0].MAP_NAME;
          this.updateMapFileLayoutHeader.data[0].MAP_MSG_VER = this.addMapFileLayoutHeader.data[0].MAP_MSG_VER;
          this.updateMapFileLayoutHeader.data[0].MAP_MSG_ID = this.addMapFileLayoutHeader.data[0].MAP_MSG_ID;
          this.updateMapFileLayoutHeader.data[0].FFL_PRCS_NO = this.addMapFileLayoutHeader.data[0].FFL_PRCS_NO;
          this.updateMapFileLayoutHeader.data[0].MPD_PRCS_NO = this.addMapFileLayoutHeader.data[0].MPD_PRCS_NO;
          this.updateMapFileLayoutHeader.data[0].CODE_CTG_ID = this.selectCodeId;
          if (this.addMapFileLayoutHeader.data[0].MAPPER_COMT != this.previousMapperComment) {
            this.updateMapFileLayoutHeader.data[0].MAPPER_COMT = this.addMapFileLayoutHeader.data[0].MAPPER_COMT;
          }
          if (this.addMapFileLayoutHeader.data[0].SCANNER_COMT != this.previousScannerComment) {
            this.updateMapFileLayoutHeader.data[0].SCANNER_COMT = this.addMapFileLayoutHeader.data[0].SCANNER_COMT;
          }
          this.updateMapFileLayoutHeader.data[0].MAP_CONV_TP =
            this.map_type_from + '2' + this.map_type_to;
          /*
            2021/01/15 203665 workflow issue 21  send only edit Data to JSON
          */
          let editField = getEditData(this.updateMapFileLayoutHeader.data[0], this.mapData[0]);
          editField.MAP_PRCS_NO = this.addMapFileLayoutHeader.data[0].MAP_PRCS_NO;
          Store.dispatch('map/modifyMapInfo', this.updateMapFileLayoutHeader).then(() => {
            console.log('--------- Finished to process ----------');
            this.sendActivate(this.updateMapFileLayoutHeader.data[0].MAP_PRCS_NO, 'MAP', editField);
            this.removeDialogRefesh({});
          });
        }
      } else {
        if (!this.$refs.refMapName.validate()) {
          this.$refs.refMapName.focus();
        } else if (!this.$refs.refMessage.validate()) {
          this.$refs.refMessage.focus();
        } else if (!this.$refs.refMapTypeForm.validate()) {
          this.$refs.refMapTypeForm.focus();
        } else if (!this.$refs.refMapTypeTo.validate()) {
          this.$refs.refMapTypeTo.focus();
        } else if (!this.$refs.refEdiVersion.validate()) {
          this.$refs.refEdiVersion.focus();
        } else if (!this.$refs.refMapperComt.validate()) {
          this.$refs.refMapperComt.focus();
        }
        return validResult;
      }
    },

    sendActivate(comId, comTp, info) {
      const params = {
        comId: comId,
        comTp: comTp,
        info: info,
      };
      this.$store
        .dispatch('updateProcessInfo', params)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log('error when send update to kafka');
        });
    },
    onFlatFileChanged(e) {
      this.addMapFileLayoutHeader.data[0].MAPPER_NAME = e.target.files[0].name;
      this.addMapFileLayoutHeader.data[0].mappfile = e.target.files[0];
    },
    onCsvFileChanged(e) {
      this.addMapFileLayoutHeader.data[0].SCANNER_NAME = e.target.files[0].name;
      this.addMapFileLayoutHeader.data[0].scanfile = e.target.files[0];
    },
    removeDialogRefesh(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
      this.$emit('search');
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    openFlatFileLayoutList() {
      this.$emit('openFlatFileLayoutList', this.addMapFileLayoutHeader.data[0].FFL_FILE_NAME);
    },
    openMappingDefinitionList() {
      this.$emit('openMappingDefinitionList', this.mapDefinitionFileName);
    },
    updateFlatFile(item) {
      this.addMapFileLayoutHeader.data[0].FFL_FILE_NAME = item.FFL_FILE_NAME;
      this.addMapFileLayoutHeader.data[0].FFL_PRCS_NO = item.FFL_PRCS_NO;
    },
    updateMapDefinitionFile(item) {
      this.mapDefinitionFileName = item.MPD_FILE_NAME;
      this.addMapFileLayoutHeader.data[0].MPD_PRCS_NO = item.MPD_PRCS_NO;
    },
    filterMapType(item) {
      if (item == 'E' || item == 'A' || item == 'X' || item == 'J') {
        if (item == 'E' || item == 'A') {
          this.$refs.eDI_version.classList.add('mandatory');
          this.icon = true;
        } else {
          this.$refs.eDI_version.classList.remove('mandatory');
          this.icon = false;
        }
        this.disable_Scan = false;
        this.addMapFileLayoutHeader.data[0].SCANNER_NAME = '';
        this.addMapFileLayoutHeader.data[0].SCANNER_FILE_ID = '';
        this.addMapFileLayoutHeader.data[0].SCANNER_SIZE = '';
      } else {
        this.$refs.eDI_version.classList.remove('mandatory');
        this.icon = false;
        this.disable_Scan = true;
      }
    },
    changeEdiList() {
      // this.getEDIMsgTypeList(); // mod by April. No need to connect. 2020.07.20
    },
    /* 2020/10/28 203737 Remove unused source
    createValidateObj(data1,data2){
       let a ={};
       a.text=data1;
       a.value= data2;
       return a;
    },*/
    openCodeTableDialog() {
      console.log('check');
      this.$emit('openCodeTableDialog', this.selectCodeId);
    },
    updateSelectCodeTitle(item) {
      this.selectCodeName = item.CODE_CTG_NAME;
      this.selectCodeId = item.CODE_CTG_ID;
    },
    openLoadFilePop(item) {
      let { mode, filetype } = item;
      if (mode == 'Load') {
        let callback = (row) => {
          Store.dispatch('common/viewFileData', row.FILE_ID).then(() => {
            if (filetype == 'mapper') {
              this.addMapFileLayoutHeader.data[0].MAPPER_NAME = row.USR_FILE_NAME;
              this.addMapFileLayoutHeader.data[0].MAPPER_FILE_ID = row.FILE_ID;
              this.addMapFileLayoutHeader.data[0].MAPPER_SIZE = row.USR_FILE_SIZE;
              this.fileLoaded = row;
            } else if (filetype == 'scanner') {
              this.addMapFileLayoutHeader.data[0].SCANNER_NAME = row.USR_FILE_NAME;
              this.addMapFileLayoutHeader.data[0].SCANNER_FILE_ID = row.FILE_ID;
              this.addMapFileLayoutHeader.data[0].SCANNER_SIZE = row.USR_FILE_SIZE;
              this.scannerLoaded = row;
            }
          });
        };
        this.$emit('openLoadFile', { mode: 'Load', filetype: filetype, callback });
      }
    },
    downloadCodeList(codeListId) {
      this.codeListCreate.data[0].CODE_CTG_ID = codeListId;
      this.codeListCreate.data[0].SITE_CODE = $cookies.get('comp-id');
      this.codeListCreate.data[0].SUB_DIR = this.mapData[0].MAP_NAME;
      Store.dispatch('map/createCodeList', this.codeListCreate).then(() => {
        if (this.codeListResult[0].successFlag === 'SUCCESS') {
          let downloadfile = new DownloadFile();
          downloadfile.data[0].FILE_ID = this.codeListResult[0].returnFileID;
          downloadfile.data[0].SAVE_NAME = 'code_list.txt';
          Store.dispatch('common/DownloadFileFromServer', downloadfile).then(() => {
            console.log('--------- Finished to process ----------');
          });
        }
      });
    },
  },
};
</script>

<style>
.add-map-layout-dialog {
  width: 888px !important;
}

.add-map-layout-dialog .inline-block-component {
  display: flex;
}

.add-map-layout-dialog .csv-file-textfield,
.add-map-layout-dialog .flatfile-textfield {
  width: calc(100% - 70px);
  padding-right: 12px;
}
.add-map-layout-dialog .csv-file-textfield {
  width: 100%;
  padding-right: 12px;
}
.add-map-layout-dialog .map-name-textfield {
  padding-right: 2px;
}

.add-map-layout-dialog .btn-active {
  width: 70px;
  margin-top: -2px;
}

.add-map-layout-dialog .dialog-header {
  background-color: #253c51;
  height: 60px !important;
}
.map-text-field {
  padding-right: 0px;
}
/* .add-map-layout-dialog span {
    font-size: 14px;
    line-height: 19px;
    color: #12083F;
    font-weight: bold;
  } */

.add-map-layout-dialog .v-btn span {
  font-weight: normal;
}

.add-map-layout-dialog .flatfile-layout-selectbox.v-text-field--outlined fieldset {
  border: none;
  border-radius: 3px;
}

.add-map-layout-dialog .flatfile-layout-selectbox.v-text-field--outlined i {
  color: #cedeff;
}

.add-map-layout-dialog .v-text-field--outlined.flatfile-layout-selectbox fieldset,
.v-text-field--outlined.text-field-flatfile-layout fieldset {
  top: -8px;
}

/* .add-map-layout-dialog .field-col {
    padding-right: 0px;
    padding-left: 20px;
    padding-top: 12px;
    line-height:30px;
  } */

/* .add-map-layout-dialog .required-col {
    padding-left: 0px;
  } */
/* .add-map-layout-dialog .not-required-col {
    padding-left: 21px;
  } */

.add-map-layout-dialog .button-col {
  padding-bottom: 10px;
}

.add-map-layout-dialog .v-text-field input,
.add-map-layout-dialog .v-text-field input::placeholder {
  font-size: 14px !important;
  font-weight: normal;
}
.data-table-select-box.custom-selectbox.map-name-selectbox .v-input__control {
  border-radius: 3px;
  border: 1px solid #cedeff;
  background: #ffffff;
}
.btn-form-control .status-rollback-button.map-dialog-btn,
.btn-form-control .delete-customer-edi-list-button.map-dialog-btn {
  width: 100px !important;
}
.add-map-layout-dialog .v-icon.notranslate.fas.fa-asterisk.theme--light {
  width: 17px;
}

/* .add-map-layout-dialog span.to-text{
  margin-right:10px;
  margin-left: 10px;
  line-height:30px;
} */
.add-map-layout-dialog .map-type-col {
  display: flex;
  padding-left: 2px;
}
.add-map-layout-dialog .flatfile-textfield.scanner-textfield {
  padding-right: 0px;
}
.scanner-load-btn {
  margin-left: 10px;
}
/* .add-map-layout-dialog span.edi-version-text{
   position: absolute;
   left: 41px;
   line-height: 30px;
} */
/* .add-map-layout-dialog.custom-add-map-layout-dialog .v-input__control{
  display:block;
} */
.add-map-layout-dialog.custom-add-map-layout-dialog .v-text-field__details {
  padding-left: 3px !important;
  margin-top: 4px;
}
.add-map-layout-dialog.custom-add-map-layout-dialog .v-text-field__details .v-messages {
  font-size: 10px;
}
.add-map-layout-dialog.custom-add-map-layout-dialog .edi-version-col {
  padding-left: 26px !important;
}
.customer-add-map-layout {
  margin-top: -20px !important;
  margin-bottom: -18px !important;
}
</style>
